import './App.css';
import React from 'react';
import logo from './logo.svg';
import ChartWithSelect from './ChartWithSelect.js';
import GenomicsDataAccessor from './GenomicsDataAccessor.js';
import Grid from '@material-ui/core/Grid'
import ReactGA from 'react-ga';

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = { genesByName : null};
    this.listOfCategories = ['Mouse_Achilles', 'Mouse_ForepawFlexors', 'Mouse_Patellar', 'Mouse_Supra', 'Rat_Achilles', 'Rat_ForepawFlexors', 'Rat_Patellar', 'Rat_Supra'];
    this.genomicsDataAccessor = new GenomicsDataAccessor(process.env.NODE_ENV, this.listOfCategories);
  }

  initializeReactGA() {
    ReactGA.initialize('UA-147607222-2');
    ReactGA.pageview('/index');
  }

  componentDidMount() {
    this.initializeReactGA()
    document.title = "ORS Tendon Transcriptional Atlas";
    this.genomicsDataAccessor.getGenomicsDataAndGiveToConsumer(rawGenesFromCSV => this.consumerForDataAccessor(rawGenesFromCSV));
  }

  consumerForDataAccessor(rawGenesFromCSV) {

    var genesByName = this.transformToGenesByName(rawGenesFromCSV)

    var listOfGenesForSelect = Object.keys(genesByName).map(function(key, index) {
      return {'value' : key, 'label' : key}
    });

    this.setState({ genesByName : genesByName, listOfGenesForSelect: listOfGenesForSelect})
  }

  transformToGenesByName(genes) {
    var genesByName = {}
    for (var i = 0; i < genes.length; i++) {
      genesByName[genes[i]['gene_name']] = genes[i]
    }
    return genesByName
  }

  render() {
    return (
      <div className="App">
        <span className="App-header">
          <div>
            <a href="https://www.hss.edu/genomics-research-center.asp"> <img align="right" className="logo" src="https://www.hss.edu/images/nav/hss-logo-flat.gif"></img></a>
            <span className="title-span">Comparative Tendon Transcriptional Atlas</span>
          </div>
          <span>
            The interactive maps below identify the expression of transcripts in mouse and rat Achilles, forepaw flexor, patellar, and supraspinatus tendons.
          </span>
          <td></td>
          <span>
            Preprint available at: <a href="https://www.biorxiv.org/content/10.1101/881797v1">https://www.biorxiv.org/content/10.1101/881797v1</a>
          </span>
          <td></td>
          <span>
            Click <a href="https://d2sju8k8hqx8os.cloudfront.net/mouse_and_rat_log2_cpm.csv">here</a> to download the raw data in csv format.
          </span>
        </span>
        {(this.state.genesByName != null) ? this.renderGrid() : null}
      </div>
    );
  }

  renderGrid() {
    return  (<Grid container className="grid">
              <Grid item xs={6}>
                <ChartWithSelect listOfGenesForSelect={this.state.listOfGenesForSelect} genesByName={this.state.genesByName} listOfCategories={this.listOfCategories}></ChartWithSelect>
                <ChartWithSelect listOfGenesForSelect={this.state.listOfGenesForSelect} genesByName={this.state.genesByName} listOfCategories={this.listOfCategories}></ChartWithSelect>
              </Grid>
              <Grid item xs={6}>
                <ChartWithSelect listOfGenesForSelect={this.state.listOfGenesForSelect} genesByName={this.state.genesByName} listOfCategories={this.listOfCategories}></ChartWithSelect>
                <ChartWithSelect listOfGenesForSelect={this.state.listOfGenesForSelect} genesByName={this.state.genesByName} listOfCategories={this.listOfCategories}></ChartWithSelect>
              </Grid>
              <Grid item xs={6}>
                <ChartWithSelect listOfGenesForSelect={this.state.listOfGenesForSelect} genesByName={this.state.genesByName} listOfCategories={this.listOfCategories}></ChartWithSelect>
                <ChartWithSelect listOfGenesForSelect={this.state.listOfGenesForSelect} genesByName={this.state.genesByName} listOfCategories={this.listOfCategories}></ChartWithSelect>
              </Grid>
              <Grid item xs={6}>
                <ChartWithSelect listOfGenesForSelect={this.state.listOfGenesForSelect} genesByName={this.state.genesByName} listOfCategories={this.listOfCategories}></ChartWithSelect>
                <ChartWithSelect listOfGenesForSelect={this.state.listOfGenesForSelect} genesByName={this.state.genesByName} listOfCategories={this.listOfCategories}></ChartWithSelect>
              </Grid>
            </Grid>);
  }
}
